import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpmFrontpageTypeShape",
  "use": "svg-icon-cpmFrontpageTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-cpmFrontpageTypeShape\"><path d=\"M8.5 5a1.5 1.5 0 1 0-3.001.001 1.5 1.5 0 0 0 3.001 0z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7.958a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm7.958 2H4v10.543l1.658-2.656a.5.5 0 0 1 .793-.072l.617.674a.5.5 0 0 0 .778-.05l1.847-2.637a.5.5 0 0 1 .822.005l1.443 2.108V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol